jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/accordion.js');
  require('./components/video.js');
  require('./components/slider.js');
  require('./components/search.js');
});
